module.exports = __webpack_public_path__ + "static/media/argon-react-white.275a2629.png";